import AddIcon from '@mui/icons-material/Add';
import { Box, useTheme } from "@mui/material";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import ShLabel from "../../../../../components/theme/label/ShLabel";
import { tokens } from "../../../../../theme";
// import { getAllStock } from "../../../../api/warehouse/stock";
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import React, { useEffect, useMemo, useRef, useState } from "react";
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { WarehouseStockCard } from "../../../../../components/global/cards/products/StockCard";
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import ShCopyButton from "../../../../../components/theme/ShCopy";
import SidepanelLoader from '../../../../../components/theme/sidepanel2/SidepanelLoader';
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../../components/theme/text/Text";
import { useBulkUpdateStockMutation, useExportPickingStockMutation, useGetAllStockQuery } from "../../../../../newapi/warehouse/stockSlice";
import { STOCK_FILTER_KEYS } from '../../../../../components/global/DataGrid/Filter';
import MDynamicValues from '../../../../../components/global/Modals/MDynamicValues';
import { useGetRelationsSelectQuery } from '../../../../../newapi/global/relation/relationSlice';
import { showToastMessage, showToastMessageRequestError, showToastMessageUpdateRequest } from '../../../../../utils/toasts';
import MLoader from '../../../../../components/global/Modals/MLoader';
import { UserPrivileges } from '../../../../../utils/permissions';
import { selectUserPermission } from '../../../../../newapi/user/authentication/authSlice';
import DropdownButton from "../../../../../components/theme/buttons/DropdownButton";
import ShDataGridSelectedActions from "../../../../../components/theme/datagrid2/ShDataGridSelectedActions";
import MConfirmation from '../../../../../components/global/Modals/MConfirmation';
import { general_states } from '../../../../../utils/staticEnums';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
import MImportData from '../../../../../components/global/Modals/MImportData';
import { ImportStandAloneFileLogo, moveStockColumns } from '../../../../../utils/importColumnDefinitions';

const SpStockDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpStockDetails/SPStockDetails"));
const SPLocationDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpLocationDetails/SpLocationDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return (
        <ButtonGroup version={2}>
            {props.canMoveStock && (
            <Shbutton
                className={"group-btn"}
                color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                onClick={props.handleMoveStockOpen}
                endIcon={<UploadOutlinedIcon/>}
                variant="contained"
            >
                {t("move_stock")}
            </Shbutton>
            )}
            <Shbutton 
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"} 
                onClick={props.handleOpen}
                isLoading={props.isExporting}
                endIcon={<DownloadOutlinedIcon/>}
                variant="contained"
            >
                {t("export")}
            </Shbutton>
        </ButtonGroup>
    );
}

const CurrentStock = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    
    const [isExtended, setIsExtended] = useState(false);
    const [spStockLoading, setSpStockLoading] = useState();

    const [locationIsExtended, setLocationIsExtended] = useState(false);
    const [spLocationLoading, setSpLocationLoading] = useState();

    const hasModifyPrivilege = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.STOCK_MANAGE])
    );

    const hasImportPrivilege = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.IMPORT_MANAGE])
    );

    // The move stock import cannot be undone, so the user confirms first and only then
    // gets the import modal.
    const canMoveStock = hasModifyPrivilege && hasImportPrivilege;
    const [moveStockConfirmOpen, setMoveStockConfirmOpen] = useState(false);
    const [moveStockImportOpen, setMoveStockImportOpen] = useState(false);

    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);
    
    const [selectedItems, setSelectedItems] = useState([]);
    const onSelected = (selectedItems) => {
        setSelectedItems(selectedItems);
    }

    let gridOptions = {
        export:true,
        disableCustomActionsOnPhone: true,
        isSidepanel: true,
        filter: [
            ...(isFulfilment ? [STOCK_FILTER_KEYS.RELATION] : []),
            STOCK_FILTER_KEYS.QUARANTINE, 
            STOCK_FILTER_KEYS.WITHOUT_STOCK
        ],
    };

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
                mobileActions:<GridActions 
                isExporting={isExporting}
                handleOpen={() => setExportStockModalOpen(true)} 
                canMoveStock={canMoveStock}
                handleMoveStockOpen={() => setMoveStockConfirmOpen(true)}
            />
        });

        return () => {
            
        }
    },[canMoveStock]);
    
    const [loaderModalOpen, setLoaderModalOpen] = useState(false);
    const loaderModal = {
        open: loaderModalOpen,
        setOpen: setLoaderModalOpen,
    };

    const [exportPickingStock, {isLoading: isExporting}] = useExportPickingStockMutation();
    const handleExportPickingStock = async (values) => {
        try {
            if(isExporting) return;
            
            loaderModal.setOpen(true);

            exportPickingStock({relationId: values.relation, type: values.type}).unwrap()
            .then(res => {
                showToastMessage("success", t("export_ready"));
            })
            .catch(e => {
                console.error(e);
                showToastMessage("error", t("export_failed"));
            })
            .finally(() => {
                loaderModal.setOpen(false);
            })
            // Download is handled automatically in the mutation
        } catch (error) {
            console.error("Export failed", error);
        }
    }
    
    const [exportStockModalOpen, setExportStockModalOpen] = useState(false);
    const exportStockModal = {
        open: exportStockModalOpen,
        setOpen: setExportStockModalOpen,
    } 
        
    const [bulkUpdateStock, {isLoading: isDeclineLoading}] = useBulkUpdateStockMutation();
    const handleUnlinkStock = async () => {
        try {
            if (isDeclineLoading) return;

            const updateObject = {
                stockIds: selectedItems,
                newState: general_states.UNLINKED
            }

            const response = await bulkUpdateStock(updateObject).unwrap();
            showToastMessageUpdateRequest(t, response);
        } catch (err) {
            showToastMessageRequestError(t('update_failed'),t, err);
        }
    }
    
    const [unlinkModalOpen, setUnlinkModalOpen] = useState(false);
    const unlinkModal = {
        open: unlinkModalOpen,
        setOpen: setUnlinkModalOpen,
        confirm: handleUnlinkStock
    } 

    const [productId, setProductId] = useState();
    const productIdRef = useRef(productId);
    
    const getProductDetails = (params) => {
        if (!params) return;
    
        const newProductId = parseInt(params.row.product.id);
        // Only update state if the productId has actually changed
        if (productIdRef.current !== newProductId) {
            if(!spStockLoading){
                setSpStockLoading(true);
            }
            setProductId(newProductId);
            productIdRef.current = newProductId; // Update the ref to the new value
        }
            setIsExtended(true);
    };
    
    const { data: relationData, relationIsLoading } = useGetRelationsSelectQuery();

    const [locationId, setLocationId] = useState();
    const locationIdRef = useRef(locationId);
    
    const getLocationDetails = (params) => {
        if (!params) return;
    
        const newProductId = parseInt(params.id);
        // Only update state if the productId has actually changed
        if (locationIdRef.current !== newProductId) {
            if(!spLocationLoading){
                setSpLocationLoading(true);
            }
            setLocationId(newProductId);
            locationIdRef.current = newProductId; // Update the ref to the new value
        }
            setLocationIsExtended(true);
    };
    

    

    const columns = useMemo(() =>[
        {
            field: "sku",
            dataField: 'product.sku',
            headerName: t("sku"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton palette={theme.palette.mode === "dark" ? "pastel" : "normal"} variant={theme.palette.mode === "dark" ? "blue" : "primary"} />
                }
                // const handleClick = () => getProductDetails(params.row.product);
                return (
                    <Box sx={{
                        width:1,
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Text clickable semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.product.sku}</Text>
                        <ShCopyButton className={"copyel"} closeAfter={1500} value={params.row.product.sku}></ShCopyButton>
                    </Box>
                );
            }
        },
        {
            field: "barcode",
            headerName: t("barcode"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <Box sx={{
                        width:1,
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Text clickable >{params.row.product.barcode}</Text>
                        <ShCopyButton color={colors.txt["primary"]} className={"copyel"} closeAfter={1500} value={params.row.product.barcode}></ShCopyButton>
                    </Box>
                );
                // return params.row.product.barcode
            },
        },
        {
            field: "description",
            headerName: t("description"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.product.description
            },
        },
        {
            field: "location",
            headerName: t("location"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton variant={"yellow"}/>
                }
                const handleClick = (event) => {
                    event.stopPropagation(); // Prevent click from propagating to the row
                    getLocationDetails(params.row.warehouseLocation);
                };
                return (
                    <Box onClick={handleClick}>
                        <ShLabel clickable size={32} fitted variant={"yellow"}>
                            {params.row.warehouseLocation.location}
                        </ShLabel>
                    </Box>
                )
            }
        },
        // {
        //     field: "handmatig",
        //     headerName: t("manual"),
        //     flex:1,
        //     renderCell : (params) => {
        //         if(params.row.skeleton) {
        //             return <ShTextSkeleton/>
        //         }
        //         return params.row.warehouseLocation.reachTypeId
        //     },
        // },
        ...isFulfilment ? [{
            field: "relation",
            headerName: t("relation"),
            flex:1,
            filter: STOCK_FILTER_KEYS.RELATION,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.product?.relation?.name ?? t("unknown")
            },
        }] : [],
        {
            field: "available",
            headerName: t("stock"),
            flex:1,
            shFilter: {
                type: "number"
            },
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.available
            },
        },
        {
            field: "quarantine",
            headerName: t("quarantine"),
            flex:1,
            shFilter: {
                type: "number"
            },
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return params.row.quarantine && params.row.quarantine > 0 ? params.row.quarantine : "";
            },
        },
        // {
        //     field: "thtdatum",
        //     headerName: t("bbdate"),
        //     flex:1,
        //     renderCell : (params) => {
        //         if(params.row.skeleton) {
        //             return <ShTextSkeleton/>
        //         }
        //         return ""
        //     },
        // },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                // console.log(cellValues.row);
                return (
                    <WarehouseStockCard
                    isFulfilment={isFulfilment}
                        skeleton={params.row.skeleton ?? false} 
                        {...params.row} 
                        onClick={() => getProductDetails(params)} 
                    />
                )
            }
        }
    ],[theme.palette.mode,t,isFulfilment,spLocationLoading]);

    const typeOptions = [
        {id: "all", name: t("all_locations")},
        {id: "general", name: t("picking_locations")},
        {id: "bulk", name: t("bulk_locations")},
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            <ShDataGrid2
                key={theme.palette.mode}
                content={useGetAllStockQuery}
                // gridActions={<GridActions></GridActions>} 
                title={t('overview')}
                gridOptions={gridOptions}
                onRowClick={getProductDetails}
                gridActions={<GridActions handleOpen={() => setExportStockModalOpen(true)} isExporting={isExporting} canMoveStock={canMoveStock} handleMoveStockOpen={() => setMoveStockConfirmOpen(true)}></GridActions>}
                sortModel={{field: columns[0].field,type:"ASC"}}
                columns={columns}
                selectable={hasModifyPrivilege}
                setSelected={hasModifyPrivilege ? onSelected : undefined}
                selectedItems={hasModifyPrivilege ? selectedItems: undefined}
                selectedActions={
                    hasModifyPrivilege &&
                    <ShDataGridSelectedActions selectedItems={selectedItems}>
                        <DropdownButton onClick={() => unlinkModal.setOpen(true)} icon={<ClearIcon/>} text={t("unlink_stock")}/>
                    </ShDataGridSelectedActions>
                }
                isRowSelectable={(row) => {
                    if(!hasModifyPrivilege || row.quantity > 0) {
                        return false;
                    }
                    return true;
                    // return row.priceIncreases?.length > 0
                }}
            />
            <MDynamicValues
                open={exportStockModal.open}
                handleClose={() => exportStockModal.setOpen(false)}
                title={t("export_stock_relation")}
                labelWidth={144}
                fields={[
                    { name: "relation", label: t("relation"), type: "list", options: relationData, search: true },
                    { name: "type", label: t("type"), type: "list", options: typeOptions }
                ]}
                onConfirm={(values) => handleExportPickingStock(values)}
            />

            {spStockLoading && 
                <SpStockDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    productId={productId}
                />
            }
            {spLocationLoading && 
                <SPLocationDetails
                    isExtended={locationIsExtended}
                    setIsExtended={setLocationIsExtended}
                    locationId={locationId}
                />
            }

            <MLoader
                open={loaderModal.open}
                handleClose={() => loaderModal.setOpen(false)}
                message={t("preparing_export")}
            />

            <MConfirmation
                open={unlinkModal.open}
                handleClose={() => unlinkModal.setOpen(false)}
                title={t("unlink_stock")}
                content={t("unlink_stock_subtitle")}
                confirm={unlinkModal.confirm}
            />

            {canMoveStock && (
                <>
                    <MConfirmation
                        open={moveStockConfirmOpen}
                        handleClose={() => setMoveStockConfirmOpen(false)}
                        title={t("move_stock")}
                        content={t("move_stock_import_confirm")}
                        confirm={() => setMoveStockImportOpen(true)}
                    />
                    <MImportData
                        open={moveStockImportOpen}
                        handleClose={() => setMoveStockImportOpen(false)}
                        logo={<ImportStandAloneFileLogo Icon={UploadOutlinedIcon} />}
                        title={t("move_stock")}
                        fileType={"voorraadverplaatsen"}
                        columns={moveStockColumns}
                    />
                </>
            )}
            
        </Box>
    );
};
export default CurrentStock;






























// component : (itemsLoaded) => {
//     return <Custom dropdown item/>
// }